module.exports = __webpack_public_path__ + "media/icon_transaction/bird-ff49f083.png";